/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUnitPaymentsPermissionRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateUnitPaymentsPermissionResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateUnitPaymentsPermission = (request: UpdateUnitPaymentsPermissionRequest, options?: CashRequestOptions) => post<UpdateUnitPaymentsPermissionRequest, UpdateUnitPaymentsPermissionResponse>("/2.0/cash/update-unit-payments-permission", request, {...options, rejectOnError: true })